//@ts-check
import * as d3 from "d3";
// import { curveBasisOpen } from "d3";

/**
 * Initiates a new File Loader
 * @class
 */class FileLoader {
  /**
   * Creates a file loader instance for added 2D Viewer.
   * File loader instance used for below functionalities :
   * 1. Load the 2D files
   * 2. Set the default view of the loaded models in the added 2D Viewer
   * 2D Viewer supports SVG file format with 100% width and 100% height only
   * @param {Object} viewerInstance Pass the instance of added 2D Viewer
   */
  constructor(viewerInstance) {
    this.registered = {};
    this.viewer = viewerInstance;
    this.setCanvasToViewBox();
  }

  /**
   * Adds Event Listener
   * @param {string} name - Name of the event
   * @param {Object} callback - Callback function
   */
  addEventListener(name, callback) {
    if (!this.registered[name]) this.registered[name] = [];
    this.registered[name].push(callback);
  }
  /**
   * Triggers Event
   * @param {string} name 
   * @param {Object} [args = []] 
   */
  triggerEvent(name, args) {
    this.registered[name].forEach((fnc) => fnc.apply(this, args));
  }
  /**
   * Sets Canvas to View Box
   */
  setCanvasToViewBox() {
    let scope = this;
    d3.select(scope.viewer.canvas).selectAll('*').remove();
    scope.viewer.zoom = d3.zoom();
    var dimensions = '0 0 ' + scope.viewer.canvas.offsetWidth + ' ' + scope.viewer.canvas.offsetHeight;
    var svg = d3.select(scope.viewer.canvas)
      .append('svg')
      .attr('viewBox', dimensions)
      .attr('preserveAspectRatio', 'xMinYMin meet')
      .call(scope.viewer.zoom.on('zoom', zoomed))
      .append('g')
      .attr('id', 'parent-' + scope.viewer.canvas.id);
    function zoomed(e) {
      svg.attr('transform', e.transform);
    }
  }

  
  /**
   * Add Drawings
   * Accepts multiple drawings for single viewer
   * @param {*} files 
   */
  addModel(files) {
    let scope = this;
    let svgFile = files;
    if (svgFile) {
      for (let i = 0; i < svgFile.length; i++) {
        scope.svgURL = URL.createObjectURL(svgFile[i]);

        d3.svg(scope.svgURL).then((data) => {

          var id = crypto.randomUUID();

          scope.viewer.parent = d3.select(scope.viewer.canvas.children[0].firstChild).append('g');
          scope.viewer.parent.attr('id', 'parent-' + id).node().append(data.documentElement);

          // Find the <image> tag within the appended data
          let backgroundImage = d3.select(scope.viewer.parent.node()).select('image');
          // If the <image> exists, assign it an ID and default to hide it
          if (!backgroundImage.empty()) {
            backgroundImage.attr('id', 'background-image-' + id);
            scope.viewer.backgroundImage = false;
            backgroundImage.style('visibility', 'hidden');
          }

          scope.viewer.content = d3.select(scope.viewer.canvas.children[0].firstChild).append('g');
          scope.viewer.content.attr('id', 'content-' + id);

          scope.viewer.interaction = d3.select(scope.viewer.canvas.children[0].firstChild).append('g');
          scope.viewer.interaction.attr('id', 'interaction-' + id);

          scope.viewer.overlay = d3.select(scope.viewer.canvas.children[0].firstChild).append('g');
          scope.viewer.overlay.attr('id', 'overlay-' + id);

          // Push all <g> element IDs into scope.arrayElements
          d3.select(scope.viewer.canvas).selectAll('g').each(function() {
            let elem = d3.select(this);
            let elemId = elem.attr('id');
            if (elemId) {
              scope.viewer.arrayElements.push(elemId);
            }
          });
          
          //seems to help infinite loader error
          //must be a more elegant way...
          setTimeout(() => {
            if (i == svgFile.length - 1) {
              scope.viewer.multipleModelPosition();
              this.triggerEvent('load-finished');
            }
          }, 300);
          scope.viewer.setSvgParameters();
        });
      }
    }

  }
}

export { FileLoader };
